import React, { useEffect } from 'react';
import moment from 'moment-timezone';

// import css
import './App.less';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

import { useMutation } from '@apollo/client';
import { REFRESH_TOKEN, GET_AUTH } from 'gql/auth';

// Pages
import Pages from './components/Pages';

moment.tz.setDefault('Asia/Hong_Kong');

function App() {
  const [refreshToken, { loading }] = useMutation(REFRESH_TOKEN, {
    update(cache, { data: { refreshToken } }) {
      cache.writeQuery({
        query: GET_AUTH,
        data: {
          auth: {
            token: refreshToken.token,
            isLoggedIn: true,
            me: refreshToken.me,
            loading: false,
          },
        },
      });
    },
    onCompleted: ({ refreshToken }) => {
      localStorage.setItem('token', refreshToken.token);
    },
    onError: () => null,
  });
  // useSetUserId();
  // usePageTracking();

  useEffect(() => {
    refreshToken({ variables: { init: true } });
  }, [refreshToken]);
  return !loading && <Pages />;
}

export default App;
